import Vue from 'vue';

// When the request succeeds
const success = (rdata, data, context) => {
    let obj = context.fictivePayments.find( obj => obj.payment_id === data.id);
    let index = context.fictivePayments.indexOf(obj);
    if(index !== -1) {
        Vue.set(context.fictivePayments, index, rdata.fictivePayment);
        // context.fictivePayments[index] = rdata.fictivePayment;
    } else {
        context.fictivePayments.push(rdata.fictivePayment);
    }

};

// When the request fails
const failed = (context, error) => {
    //context.showToasterError(error);
};

export default (context, data) => {
    return Vue.$http.post('/invoice-payment', data).then((response) => {
        if (response.status === 200) {
            success(response.data, data, context);
        }
    })
    .catch((error) => {
        failed(context, error);
    });
};


// WEBPACK FOOTER //
// ./src/app/services/invoice/updatePayment.js